import Vue from 'vue';
import Vuex from 'vuex';

/**Modules */
import field from './modules/field'
import format from './modules/format'
import records from './modules/records'
import city from './modules/city'
import entity from './modules/entity'
import user from './modules/user'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        field,
        format,
        records,
        city,
        entity,
        user
    }
})

export default store;